import { render } from "./ObjectiveForm.vue?vue&type=template&id=1f8977ec&scoped=true"
import script from "./ObjectiveForm.vue?vue&type=script&lang=js"
export * from "./ObjectiveForm.vue?vue&type=script&lang=js"

import "./ObjectiveForm.vue?vue&type=style&index=0&id=1f8977ec&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8977ec"]])

export default __exports__